import { forwardRef } from 'react';
import { Button, type ButtonProps } from './Button';
import { Tooltip } from './Tooltip';
import { cn } from '@/lib/cn';

export interface IconButtonProps extends Omit<ButtonProps, 'children' | 'aria-label'> {
  /** Required: icon only buttons need an accessible name. Also shown as a tooltip. */
  label: string;
  children: React.ReactNode;
  tooltip?: boolean;
  tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, children, tooltip = true, tooltipSide, variant = 'ghost', size = 'icon', className, ...props },
  ref,
) {
  const btn = (
    <Button ref={ref} variant={variant} size={size} aria-label={label} className={cn('shrink-0 px-0', className)} {...props}>
      {children}
    </Button>
  );
  return tooltip ? <Tooltip content={label} side={tooltipSide}>{btn}</Tooltip> : btn;
});
